/* eslint-disable */
import App from '../packages/app/src/app.vue'

import Page from '../packages/page/src/page.vue'
import Container from '../packages/container/src/container'
import PcContainer from '../packages/pc-container/src/pcContainer.vue'
import Tabs from '../packages/tabs/src/tabs.vue'

import Component from './Component'
import Text from '../packages/text/src/text.vue'
import Button from '../packages/button/src/button.vue'
import Image from '../packages/image/src/image.vue'
import Link from '../packages/link/src/link.vue'
import Qrcode from '../packages/qrcode/src/qrcode.vue'

import renderView from './mixins/renderView'

const containers = [
  App,

  Page,
  Container,
]

const extendContainer = [
  PcContainer,
  Tabs,
]

const components = [
  Text,
  Button,
  Link,
  Image,
  Qrcode,
]

const hooks = ['created', 'beforeMount', 'mounted', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'beforeDestroy', 'destroyed']
const mixin = {
  inject: {
    app: {
      default: {}
    }
  }
}

hooks.forEach(hook => {
  mixin[hook] = function () {
    if (this.config && this.config.renderType === 1) {
      switch (hook) {
        case 'created': {
          if (this.config.id && this.app && this.app.addComponent) {
            this.app.addComponent(this)
          }
          break
        }
        case 'destroyed': {
          if (this.config.id && this.app && this.app.removeComponent) {
            this.app.removeComponent(this)
          }
        }
      }

      if (typeof this.config[hook] === 'function') {
        this.config[hook].call(this, this, this.app)
      }
    }
  }
})

const pushMixin = (component, mixins) => {
  component.mixins = component.mixins || []
  component.mixins.push(...mixins)
}

export default {
  ...containers,
  ...components,

  hooksMixin (component) {
    pushMixin(component, [mixin, renderView])
  },

  install (Vue) {
    // 全局事件处理
    const EventBus = new Vue()
    if (!Vue.prototype.$bus) {
      Object.defineProperties(Vue.prototype, {
        $bus: {
          get: function () {
            return EventBus
          }
        }
      })
    }

    components.forEach(component => {
      this.hooksMixin(component)
      Vue.component(component.name, component)
    })

    extendContainer.forEach(component => {
      pushMixin(component, [renderView])
    })

    containers.concat(extendContainer).forEach(component => {
      Vue.component(component.name, component)
    })

    Vue.component(Component.name, Component)
  }
}
